import React, { useEffect, useRef, useState } from 'react';
import './About.css';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const aboutRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const node = aboutRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (node) {
      observer.observe(node);
    }

    return () => {
      if (node) {
        observer.unobserve(node);
      }
    };
  }, []);

  return (
    <div className="about-container" ref={aboutRef}>
      <h2 className={isVisible ? 'fade-in-left' : 'fade-out-left'}>
        About Me
      </h2>
      <p className={isVisible ? 'fade-in-right' : 'fade-out-right'}>
        I&apos;m a Software Engineer at Red Hat with a B.Tech in Computer Science from Vellore Institute of Technology, combining <strong>published research in AI/ML</strong> with <strong>enterprise-grade software development</strong>.
        <br /><br />
        <strong>Research:</strong> My work on <em>Alzh-Net</em>, a dual-CNN architecture for MRI-based Alzheimer&apos;s diagnosis, was published in <em>Biomedical Signal Processing and Control</em> (Elsevier, 2024). The model employs multi-scale feature extraction with varied strides and max-pooling layers to capture both global patterns and fine-grained details in brain scans. At IIIT Bangalore, I conducted research on extending Surface-to-Volume Ratio regularization for multiclass classification of imbalanced datasets, proposing novel decision boundary transformations that improve accuracy on skewed distributions. I&apos;ve also developed deep learning frameworks for early cataract detection, achieving high accuracy on datasets of 10,000+ eye images.
        <br /><br />
        <strong>Industry:</strong> At Red Hat, I work on the Ansible Automation Platform—building tools that power enterprise automation at scale. I led the Ansible Automation Portal Installer to General Availability, enabling multi-cloud deployments across AWS, VMware, and KVM with streamlined cloud-init workflows. I develop and maintain Ansible collections for Terraform Cloud/Enterprise integration, implementing workspace management modules with 90%+ code coverage. On the AI front, I architected an intelligent GitHub triage bot using Gemini that reduced manual issue classification by 70%, featuring prompt injection detection and token-optimized context retrieval via Repomix. I&apos;ve implemented managed credential types in AWX for secure Terraform integrations, remediated 100+ CVE vulnerabilities across portal components, and actively contribute to open source projects including VS Code Ansible, Ansible Creator CLI, and the ansible.platform collection.
        <br /><br />
        Outside work, you&apos;ll find me playing cricket, gaming on Valorant, or exploring new Linux distributions. Always open to collaborating on impactful projects!
      </p>
    </div>
  );
};

export default About;
